const Export = ({ size }) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" widt={size} height={size} viewBox={`0 0 24 24`} >
        <path d="M20 15V18.3333C20 18.7754 19.8244 19.1993 19.5118 19.5118C19.1993 19.8244 18.7754 20 18.3333 20H6.66667C6.22464 20 5.80072 19.8244 5.48816 19.5118C5.17559 19.1993 5 18.7754 5 18.3333V15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M8.33203 10.8334L12.4987 15L16.6654 10.8334" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12.5 15V5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

export default Export;
